// extracted by mini-css-extract-plugin
export default {"custom-toast":"custom-toast_DgHfnjzP","toast-sm-width":"toast-sm-width_VBfBU9k9"};